import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from "react-router-dom";
import { Anchor, AnchorProps } from "@mantine/core";

export interface LinkProps extends AnchorProps, Omit<Partial<ReactRouterLinkProps>, "color"> {
    href?: string;
}

export const Link = (props: LinkProps) => {
    return <Anchor {...props} component={props.to ? ReactRouterLink : undefined} to={props.to} />;
};
